<template>
  <div
    class="app-accordion-item"
    :class="{ 'app-accordion-item--dark': darkMode }"
  >
    <a class="app-accordion-item__title" @click="toogle">
      <strong><slot name="title"></slot></strong>
      <FontAwesomeIcon icon="chevron-down"
        class="app-accordion-item__title__icon"
        :class="{
          'app-accordion-item__title__icon--openned': openned,
          'app-accordion-item__title__icon--closing': closing
        }"
      />
    </a>
    <div
      class="app-accordion-item__content"
      :class="{
        'app-accordion-item__content--openned': openned,
        'app-accordion-item__content--closing': closing
      }"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppAccordionItem',
  data () {
    return {
      openned: false,
      closing: false
    }
  },
  computed: {
    ...mapState('global', [
      'darkMode'
    ])
  },
  methods: {
    toogle () {
      this.openned = !this.openned
      this.closing = !this.openned
    }
  }
}
</script>

<style lang="scss" scoped>
.app-accordion-item {
  display: flex;
  flex-direction: column;

  &:first-of-type {
    .app-accordion-item__title {
      border-top: none;
    }
  }
  &__title {
    position: relative;
    width: 100%;
    padding: 1.8rem 3rem 1.8rem 1rem;
    cursor: pointer;
    border-top: 1px solid map-get($color-util, 'light');
    text-decoration: none;
    color: map-get($color-util, 'darkest');

    &__icon {
      position: absolute;
      top: 1.8rem;
      right: 1rem;
      width: 16px;
      height: 16px;
      transition: transform 0.5s;

      &--openned {
        transform: rotate(180deg);
      }
      &--closing {
        transform: rotate(0deg);
      }
    }
  }
  &__content {
    padding: 0 1rem;
    color: map-get($color-util, 'darkest');
    background-color: map-get($color-util, 'lightest');
    border-top: 1px solid map-get($color-util, 'light');
    line-height: 150%;
    transition: max-height 0.5s, padding 0.5s;
    max-height: 0;
    overflow: hidden;

    &--openned {
      padding: 1.5rem 1rem;
      max-height: 1000px;
    }
    &--closing {
      padding: 0 1rem;
      max-height: 0;
    }

    a:hover {
      text-decoration: underline;
    }
  }
  &--dark {
    .app-accordion-item__title {
      color: #fff;
    }
    .app-accordion-item__content {
      color: #fff;
      background-color: map-get($color-util, 'darkest');
    }
  }
}
</style>
